import script from "./Cookie.vue?vue&type=script&setup=true&lang=js"
export * from "./Cookie.vue?vue&type=script&setup=true&lang=js"

import "./Cookie.vue?vue&type=style&index=0&id=2b19b30e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b19b30e"]])

export default __exports__